import http, {SuccessEvent} from "../../common/ts/core/http";

function createEmailAlert({search, email, wantNews = false , successEvent} : {search: string, email: string, wantNews?: boolean, successEvent?: SuccessEvent}) {
    return new http.PostEvent({
        url: "/servletGestionAlertas",
        body: {
            'what': search,
            'email': email,
            'action': '2',
            'receiveDems': wantNews ? 'on' : 'off',
        },
        formUrlencoded: true,
        successEvent
    })
}

function createMultipleEmailAlerts({ searches, email, wantNews = false, successEvent } : { searches: string[], email: string, wantNews?: boolean, successEvent?: SuccessEvent }) {
    return new http.PostEvent({
        url: "/servletGestionAlertas",
        body: {
            'whats': searches.toString(),
            'email': email,
            'action': '2',
            'receiveDems': wantNews ? 'on' : 'off',
        },
        formUrlencoded: true,
        successEvent
    })
}

export default {
    events: {
        createEmailAlert,
        createMultipleEmailAlerts,
    }
}